﻿export interface IRccapCenterResponseAdditionalQuestionAnswer {
    id: number;
    answer: string;
}
